// extracted by mini-css-extract-plugin
export default {"root":"ChangeLanguage_root__yaKTb","item":"ChangeLanguage_item__7Bl9G"};